import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./utils/element.js";
import 'animate.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import http from './api/http'
Vue.prototype.$http = http


Vue.use(ElementUI, {locale})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
